import { useContext } from "react";
import { Box } from "@otrium/core";
import { useRouter } from "next/router";
import { AppCtx } from "src/contexts/app.context";
import { ServiceBanner } from "src/organisms/Header/ServiceBanner";
import FooterTopSalesLanding from "src/molecules/Footer/FooterTopSalesLanding";
import FooterCopyright from "src/molecules/Footer/FooterCopyright";
import { Footer } from "src/molecules/Footer";
import { isIncludedInSelectedBrands } from "src/utils/selectedBrands";

export default function SalesLandingLayout({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  const { locale } = useContext(AppCtx);
  const router = useRouter();

  return isIncludedInSelectedBrands(router.asPath) ? (
    <div>
      {children}
      <Footer />
    </div>
  ) : (
    <div>
      <Box display={["none", "none", "none", "block"]}>
        <ServiceBanner />
      </Box>
      {children}
      <FooterTopSalesLanding />
      <FooterCopyright locale={locale} />
    </div>
  );
}
